import { configureTrpcClient, QueryClientProvider, queryClient } from '@faceup/trpc'
import { DEFAULT_LANGUAGE } from '@faceup/utils'
import { type ReactNode, useContext, useEffect } from 'react'
import { LanguageContext } from './App/LanguageContext'

const dynamicHeaderValues = {
  language: DEFAULT_LANGUAGE as string,
}

configureTrpcClient({
  url: import.meta.env.VITE_API_URL?.replace('graphql', 'trpc') ?? '',
  getHeaders: () => ({
    language: dynamicHeaderValues.language || DEFAULT_LANGUAGE,
  }),
})

queryClient.setDefaultOptions({
  queries: {
    retry: 1,
    refetchOnWindowFocus: false,
  },
})

type TrpcProviderProps = {
  children: ReactNode
}

export const TrpcProvider = ({ children }: TrpcProviderProps) => {
  const { language } = useContext(LanguageContext)

  useEffect(() => {
    dynamicHeaderValues.language = language
  }, [language])

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
